import React from 'react'
import { Form, Text } from 'components/forms'
import prepareMutationData from './prepareMutationData'
import { Col, Row } from 'react-flexbox-grid'
import { appConfig } from 'gql/query'
import { useQuery } from 'components/graphql'
import { useTranslation } from 'react-i18next'
import ContentBlock, { ExpandableBlocks } from 'components/ContentBlock'
import { StyledForm } from './StyledAccountingForm'

const Accounting = ({ data, updateMutation, disabled, countryId }) => {

	const [t] = useTranslation()
	useQuery(appConfig.pointsSystem)
	const handleSubmit = (vals, category) => {
		if(vals) {
			const mutationData = prepareMutationData(vals?.[category], category, data?.[category]?.map(el => el.originalIndex))
			mutationData && updateMutation(mutationData)
		}
	}

	const fields = (category) => {
		const cols = []
		const inputData = data?.[category] || []

		inputData.forEach((row, i) => {
			cols.push(
				<Text
					key={`${row.label}_${i}`}
					field={`[${category}][${i}].value`}
					label={row.label}
					disabled={disabled && category !== 'creditCards'}
				/>
			)
		})

		return cols
	}

	return(
		<ExpandableBlocks>
			<ContentBlock label={t('common.strings.general')} startExpanded >
				<StyledForm
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'general')}
					smartSubmit
				>
					{() => fields('general')}
				</StyledForm>
			</ContentBlock>
			{Boolean(data?.creditCards?.length) && <ContentBlock label={t('common.strings.otherPaymentOptions')} >
				<StyledForm
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'creditCards')}
					smartSubmit
				>
					{() => fields('creditCards')}
				</StyledForm>
			</ContentBlock>}
			<ContentBlock label={t('closing_section.fields.vat')} >
				<Row>
					<Col xs={4}>
						<Form
							initialValues={data}
							onSubmit={(e) => handleSubmit(e, 'salesNames')}
							smartSubmit
						>
							{() => fields('salesNames')}
						</Form>
					</Col>
					{countryId === '1' &&
						<>
							<Col xs={4}>
								<Form
									initialValues={data}
									onSubmit={(e) => handleSubmit(e, 'taxAccountSorted')}
									smartSubmit
								>
									{() => fields('taxAccountSorted')}
								</Form>
							</Col>
							<Col xs={4}>
								<Form
									initialValues={data}
									onSubmit={(e) => handleSubmit(e, 'taxCodeSorted')}
									smartSubmit
								>
									{() => fields('taxCodeSorted')}
								</Form>
							</Col>
						</>
					}
				</Row>
			</ContentBlock>
			{Boolean(data?.outcome?.length) && <ContentBlock label={t('product_section.strings.expenses')} >
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'outcome')}
					smartSubmit
				>
					{() => fields('outcome')}
				</Form>
			</ContentBlock>}
			<ContentBlock label={t('product_section.sub_sections.loyalty_card')} >
				<Form
					initialValues={data}
					onSubmit={(e) => handleSubmit(e, 'accountPrepaidCard')}
					smartSubmit
				>
					{() => fields('accountPrepaidCard')}
				</Form>
			</ContentBlock>
		</ExpandableBlocks>
	)
}

export default Accounting
